/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Injectable } from '@angular/core';
import { LoggerService } from '../../shared/services/logger.service';
import { Feature } from 'ol';
import { StyleLike } from 'ol/style/Style';
import { FeatureFormatter } from '../state/featureFormatter';

@Injectable()
export class FeatureService {
    private featureStore = new Map<string, Feature>();

    constructor(logger: LoggerService) {}

    getFeature(id: string) {
        const orig = this.featureStore.get(id);
        if (orig) {
            const newFeature = orig.clone();
            newFeature.setId(id);
            return newFeature;
        }
        return null;
    }
    getFeatures(ids: string[] = []) {
        const features: Feature[] = [];
        ids.forEach((id) => {
            const feature = this.getFeature(id);
            if (feature) {
                features.push(feature);
            }
        });
        return features;
    }
    getLayerFeatures(layerName: string) {
        const features: Feature[] = [];
        for (const [key, feature] of this.featureStore) {
            if (key.startsWith(layerName)) {
                features.push(feature);
            }
        }
        return features;
    }

    setFeatures(features: Feature[]) {
        features.forEach((feature) => {
            this.addFeature(feature);
        });
    }

    addFeature(feature: Feature) {
        this.featureStore.set(feature.getId().toString(), feature);
    }

    storeFeature(feature: Feature): string {
        const id = feature.getId().toString();
        this.featureStore.set(id, feature);
        return id;
    }

    storeFeatures(features: Feature[]): string[] {
        const featureIds: string[] = [];
        features.forEach((feature) => featureIds.push(this.storeFeature(feature)));
        return featureIds;
    }

    updateFeatureStyle(featureIds: string[], style: StyleLike) {
        // this.getFeatures(featureIds).forEach((feature) => {
        //     feature.setStyle(style);
        // });
    }
}
